import { isValidElement } from 'react';
import {v4 as uuidv4} from 'uuid';

const faqOneData = [
    {
        id: uuidv4(),
        ques: 'How do I find the right architect for my project?',
        ans: 'We have intentionally never developed a stylistic formula for our work, which is why our projects never quite look or feel the same. Each of our spaces is the result of our ability to listen.',
        index: 'faq1',
    },

    {
        id: uuidv4(),
        ques: 'What services do architects provide?',
        ans: 'We have intentionally never developed a stylistic formula for our work, which is why our projects never quite look or feel the same. Each of our spaces is the result of our ability to listen.',
        index: 'faq2'
    },

    {
        id: uuidv4(),
        ques: 'How do I find the right architect for my project?',
        ans: 'We have intentionally never developed a stylistic formula for our work, which is why our projects never quite look or feel the same. Each of our spaces is the result of our ability to listen.',
        index: 'faq3'
    },

    {
        id: uuidv4(),
        ques: 'How are architects compensated?',
        ans: 'We have intentionally never developed a stylistic formula for our work, which is why our projects never quite look or feel the same. Each of our spaces is the result of our ability to listen.',
        index: 'faq4'
    },

    {
        id: uuidv4(),
        ques: 'Can you work with clients long distance?',
        ans: 'We have intentionally never developed a stylistic formula for our work, which is why our projects never quite look or feel the same. Each of our spaces is the result of our ability to listen.',
        index: 'faq5'
    },

]

export default faqOneData;